import { Box, SimpleGrid } from '@chakra-ui/react'
import React from 'react'
import GitHubCalendar from 'react-github-calendar'
import '../Styles/Skill.css'
import { AiFillGithub, AiFillHtml5 } from "react-icons/ai";
import { FaCss3, FaCuttlefish, FaLinux, FaNodeJs, FaReact } from "react-icons/fa";
import { SiJavascript, SiMongodb, SiRedux, SiChakraui } from "react-icons/si";
const Skill = () => {
  return (
    <Box className="skill_container">
        <Box className='banner'>
          <h1><strong style={{fontSize:"60px",color:"rgb(225, 51, 51)"}}>S</strong>kills</h1>
        </Box>
        <Box className="skill_icons"> 
        <SimpleGrid columns={[1,2,2,4]} spacing={20} width="fit-content" margin="auto" p="50px" align="center">
        <Box className="tech"> 
        {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg" width="80px" alt="language_Icon" color="black" /> */}
        <FaCuttlefish size="80px" color="#ff6596"/>
        
        </Box>
        <Box className="tech">
          {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg" width="80px" alt="language_Icon" /> */}
          <AiFillHtml5 size="80px" color="#ff6596" />
          </Box>
        <Box className="tech">
          {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg" width="80px" alt="language_Icon" /> */}
          <FaCss3 size="80px" color="#ff6596"/>
          </Box>
       <Box className="tech">
         {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg" width="80px" alt="language_Icon" /> */}
         <SiRedux size="80px" color="#ff6596"/>
       </Box>
        <Box className="tech">
        {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg" width="80px" alt="language_Icon" /> */}
        <FaReact size="80px" color="#ff6596"/>
        </Box>
        <Box className="tech">
        {/* <img src="https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667" width="80px" alt="language_Icon" /> */}
        <AiFillGithub size="80px" color="#ff6596"/>
        </Box>
        <Box className="tech">
        {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg" width="80px" alt="language_Icon" /> */}
        <SiJavascript size="80px" color="#ff6596"/>
        </Box>
       <Box className="tech">
       {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg" width="80px" alt="language_Icon" /> */}
       <FaLinux size="80px" color="#ff6596" />
       </Box>
       <Box className="tech">
       {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg" width="80px" alt="language_Icon" /> */}
       <SiMongodb size="80px" color="#ff6596" />
       </Box>
       <Box className="tech">
       {/* <img src="https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg" width="80px" alt="language_Icon" /> */}
       <FaNodeJs size="80px" color="#ff6596" />
       </Box>
         </SimpleGrid>
        </Box>
         <Box align={"center"} m="auto" mt="120px" w="60%">
         <GitHubCalendar username="Aniket-bansal"  year={new Date().getFullYear()}/>
         </Box>
        
    </Box>
  )
}

export default Skill